module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/venezia.e3827be0f94ce281fae4f8e5b06e7a3d.jpg";